// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Global Container --- */
.help-page {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  background: #f2eee6;
  padding-bottom: 50px;
}

.help-page .help-hero {
  width: 100%;
  height: auto;
  overflow: hidden;
  background: #05090d;
}

.help-page .help-hero-inner {
  position: relative;
  width: min(100%, 1500px);
  aspect-ratio: 1440 / 590;
  margin-inline: auto;
  overflow: hidden;
}

.help-page .help-hero-inner::after {
  position: absolute;
  inset: 0;
  z-index: 1;
  content: "";
  pointer-events: none;
  background: linear-gradient(90deg, rgba(5, 9, 13, .68) 0%, rgba(5, 9, 13, .18) 46%, transparent 68%);
}

.help-page .help-hero-content-container {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1500px;
  height: 100%;
  margin: 0 auto;
  padding-inline: 64px;
  box-sizing: border-box;
}

.help-page .help-hero-layout {
  width: 100%;
  height: 100%;
  margin: 0;
  display: grid;
  grid-template-columns: minmax(0, 560px) minmax(0, 1fr);
  align-items: center;
}

.help-page .help-hero-copy {
  width: 100%;
  max-width: 560px;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.help-page .help-hero-copy h1 {
  margin: 0;
  color: #f4f1ea;
  font-family: "Playfair Display", serif;
  font-size: clamp(48px, 4vw, 56px);
  font-weight: 400;
  line-height: .98;
  letter-spacing: .025em;
}

.help-page .help-hero-copy span {
  display: block;
  width: 44px;
  height: 1px;
  margin-top: 17px;
  background: #b88a44;
}

.help-page .help-hero-copy p {
  max-width: 430px;
  margin: 16px 0 0;
  color: rgba(244, 241, 234, .72);
  font: 400 14px/1.6 "Poppins", sans-serif;
  letter-spacing: .035em;
}

.help-page .help-hero-media {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
}

.help-page .help-hero-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: right 60%;
  border: 0;
  margin: 0;
}

@media (max-width: 1100px) {
  .help-page .help-hero-content-container { padding-inline: 32px; }
  .help-page .help-hero-copy { max-width: 480px; }
}
@media (max-width: 900px) {

}

@media (max-width: 760px) {
  .help-page .help-hero-content-container { padding-inline: 16px; }
  .help-page .help-hero-copy { max-width: 360px; }
}
@media (max-width: 600px) {
  .help-page .help-hero-copy h1 { font-size: 40px; }

  .help-page .help-hero-copy p {
    max-width: 310px;
    margin-inline: auto;
    font-size: 11px;
  }
}
.help-page .help-container {
  margin-top: 50px;
  margin-bottom: 50px;
  flex-direction: row;
}

/* --- Menu & Tabs --- */
.help-page .help-menu {
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 1px solid rgba(16, 32, 43, 0.1);
  background: #e8e1d7;
}

.help-page .help-menu .table-list {
  display: flex;
  justify-content: space-between;
}

.help-page .css-1gsv261 {
  width: 75%;
}

.help-page .css-heg063-MuiTabs-flexContainer {
  justify-content: space-between;
}

.help-page .css-19 {
  padding-top: 24px;
}

.help-page .help-main-content {
  width: 100%;
  height: auto;
  background: #f2eee6;
}

/* --- Rules Box (FAQ/Terms) --- */
.help-page .rules-box {
  padding: 30px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #151d21; /* Darker luxury shade */
  border: 1px solid #333;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);
  border-radius: 12px;
}

.rules-box .rules-frame {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* The lines inside your FAQ area */
.rules-box .rules-frame p {
  border-bottom: 1px solid #222;
  color: #ffffff; /* White text for contrast */
  font-family: 'Poppins', sans-serif;
  font-weight: 300;
  font-size: 1rem;
  padding: 15px 0;
  margin: 0;
}

.help-page .accordion-menu {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  background: #f2eee6;
}

/* --- Admin Contact Form --- */
.help-page .admin-letter-box {
  padding: 60px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #151d21;
  border: 1px solid #333;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);
  border-radius: 12px;
}

.help-page .admin-letter-box .admin-letter-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.help-page .admin-letter-container .admin-letter-frame {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}

.help-page .admin-letter-frame span {
  font-family: 'Playfair Display', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 28px;
  color: #d7b586; /* Champagne Gold Header */
}

.help-page .admin-letter-frame p {
  margin-top: 20px;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 26px;
  color: #a0a0a0;
}

.help-page .admin-letter-frame .admin-input-box {
  margin-top: 30px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.help-page .admin-letter-frame .admin-input-box label {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #d7b586;
}

.help-page .admin-letter-frame .admin-input-box input {
  margin-top: 10px;
  padding: 20px;
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  background: #0b1114;
  border: 1px solid #333;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
}

.help-page .admin-letter-frame .admin-input-box textarea {
  margin-top: 10px;
  padding: 20px;
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  background: #0b1114;
  border: 1px solid #333;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/css/help.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,oGAAoG;AACtG;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sCAAsC;EACtC,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;EACT,SAAS;AACX;;AAEA;EACE,0CAA0C,oBAAoB,EAAE;EAChE,6BAA6B,gBAAgB,EAAE;AACjD;AACA;;AAEA;;AAEA;EACE,0CAA0C,oBAAoB,EAAE;EAChE,6BAA6B,gBAAgB,EAAE;AACjD;AACA;EACE,gCAAgC,eAAe,EAAE;;EAEjD;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB,EAAE,wBAAwB;EAC7C,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,6BAA6B;EAC7B,cAAc,EAAE,4BAA4B;EAC5C,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc,EAAE,0BAA0B;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* --- Global Container --- */\n.help-page {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  background: #f2eee6;\n  padding-bottom: 50px;\n}\n\n.help-page .help-hero {\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n  background: #05090d;\n}\n\n.help-page .help-hero-inner {\n  position: relative;\n  width: min(100%, 1500px);\n  aspect-ratio: 1440 / 590;\n  margin-inline: auto;\n  overflow: hidden;\n}\n\n.help-page .help-hero-inner::after {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  content: \"\";\n  pointer-events: none;\n  background: linear-gradient(90deg, rgba(5, 9, 13, .68) 0%, rgba(5, 9, 13, .18) 46%, transparent 68%);\n}\n\n.help-page .help-hero-content-container {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 1500px;\n  height: 100%;\n  margin: 0 auto;\n  padding-inline: 64px;\n  box-sizing: border-box;\n}\n\n.help-page .help-hero-layout {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 560px) minmax(0, 1fr);\n  align-items: center;\n}\n\n.help-page .help-hero-copy {\n  width: 100%;\n  max-width: 560px;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.help-page .help-hero-copy h1 {\n  margin: 0;\n  color: #f4f1ea;\n  font-family: \"Playfair Display\", serif;\n  font-size: clamp(48px, 4vw, 56px);\n  font-weight: 400;\n  line-height: .98;\n  letter-spacing: .025em;\n}\n\n.help-page .help-hero-copy span {\n  display: block;\n  width: 44px;\n  height: 1px;\n  margin-top: 17px;\n  background: #b88a44;\n}\n\n.help-page .help-hero-copy p {\n  max-width: 430px;\n  margin: 16px 0 0;\n  color: rgba(244, 241, 234, .72);\n  font: 400 14px/1.6 \"Poppins\", sans-serif;\n  letter-spacing: .035em;\n}\n\n.help-page .help-hero-media {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n}\n\n.help-page .help-hero-image {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: right 60%;\n  border: 0;\n  margin: 0;\n}\n\n@media (max-width: 1100px) {\n  .help-page .help-hero-content-container { padding-inline: 32px; }\n  .help-page .help-hero-copy { max-width: 480px; }\n}\n@media (max-width: 900px) {\n\n}\n\n@media (max-width: 760px) {\n  .help-page .help-hero-content-container { padding-inline: 16px; }\n  .help-page .help-hero-copy { max-width: 360px; }\n}\n@media (max-width: 600px) {\n  .help-page .help-hero-copy h1 { font-size: 40px; }\n\n  .help-page .help-hero-copy p {\n    max-width: 310px;\n    margin-inline: auto;\n    font-size: 11px;\n  }\n}\n.help-page .help-container {\n  margin-top: 50px;\n  margin-bottom: 50px;\n  flex-direction: row;\n}\n\n/* --- Menu & Tabs --- */\n.help-page .help-menu {\n  width: 100%;\n  height: 60px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  border-bottom: 1px solid rgba(16, 32, 43, 0.1);\n  background: #e8e1d7;\n}\n\n.help-page .help-menu .table-list {\n  display: flex;\n  justify-content: space-between;\n}\n\n.help-page .css-1gsv261 {\n  width: 75%;\n}\n\n.help-page .css-heg063-MuiTabs-flexContainer {\n  justify-content: space-between;\n}\n\n.help-page .css-19 {\n  padding-top: 24px;\n}\n\n.help-page .help-main-content {\n  width: 100%;\n  height: auto;\n  background: #f2eee6;\n}\n\n/* --- Rules Box (FAQ/Terms) --- */\n.help-page .rules-box {\n  padding: 30px;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #151d21; /* Darker luxury shade */\n  border: 1px solid #333;\n  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n}\n\n.rules-box .rules-frame {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* The lines inside your FAQ area */\n.rules-box .rules-frame p {\n  border-bottom: 1px solid #222;\n  color: #ffffff; /* White text for contrast */\n  font-family: 'Poppins', sans-serif;\n  font-weight: 300;\n  font-size: 1rem;\n  padding: 15px 0;\n  margin: 0;\n}\n\n.help-page .accordion-menu {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  background: #f2eee6;\n}\n\n/* --- Admin Contact Form --- */\n.help-page .admin-letter-box {\n  padding: 60px;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #151d21;\n  border: 1px solid #333;\n  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n}\n\n.help-page .admin-letter-box .admin-letter-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.help-page .admin-letter-container .admin-letter-frame {\n  margin-top: 30px;\n  display: flex;\n  flex-direction: column;\n}\n\n.help-page .admin-letter-frame span {\n  font-family: 'Playfair Display', serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 28px;\n  color: #d7b586; /* Champagne Gold Header */\n}\n\n.help-page .admin-letter-frame p {\n  margin-top: 20px;\n  font-family: 'Poppins', sans-serif;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 15px;\n  line-height: 26px;\n  color: #a0a0a0;\n}\n\n.help-page .admin-letter-frame .admin-input-box {\n  margin-top: 30px;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.help-page .admin-letter-frame .admin-input-box label {\n  font-family: 'Poppins', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  color: #d7b586;\n}\n\n.help-page .admin-letter-frame .admin-input-box input {\n  margin-top: 10px;\n  padding: 20px;\n  width: 100%;\n  height: 60px;\n  display: flex;\n  flex-direction: column;\n  background: #0b1114;\n  border: 1px solid #333;\n  border-radius: 8px;\n  font-family: 'Poppins', sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  color: #ffffff;\n}\n\n.help-page .admin-letter-frame .admin-input-box textarea {\n  margin-top: 10px;\n  padding: 20px;\n  width: 100%;\n  height: 150px;\n  display: flex;\n  flex-direction: column;\n  background: #0b1114;\n  border: 1px solid #333;\n  border-radius: 8px;\n  font-family: 'Poppins', sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
